import { Timestamp } from "firebase/firestore";
import { TASK_TYPE, TASK_PRIORITY, TASK_STATUS } from "../../constants/tasks";

/**
 * Converte os dados do formulário/tabela de Tarefa para a estrutura do Firestore (desnormalizado).
 */
export const taskToFirestore = (data, tenant, authUser) => {
    return {
        idTenant: tenant.idTenant,
        title: data.title?.trim() || "",
        description: data.description?.trim() || "",
        type: data.type || TASK_TYPE.CONTACT,
        priority: data.priority || TASK_PRIORITY.NORMAL,
        status: data.status || TASK_STATUS.NEW,
        
        scheduledDate: data.scheduledDate,
        scheduledTime: data.scheduledTime,

        // Desnormalizando as informações do membro
        idMember: data.selectedMember?.id,
        memberName: data.selectedMember?.fullName || data.selectedMember?.label || null,
        memberEmail: data.selectedMember?.email,
        memberPhone: data.selectedMember?.phone,
        memberPhotoUrl: data.selectedMember?.photoUrl,

        // Desnormalizando as informações do funcionário responsável (compatibilidade legada)
        idEmployee: data.selectedEmployees?.[0]?.id,
        employeeName: data.selectedEmployees?.[0]?.fullName || data.selectedEmployees?.[0]?.name || null,
        employeeEmail: data.selectedEmployees?.[0]?.email,
        employeePhone: data.selectedEmployees?.[0]?.phone,
        employeePhotoUrl: data.selectedEmployees?.[0]?.photoUrl,
        
        // Múltiplos responsáveis
        assignedEmployees: (data.selectedEmployees || []).map(emp => ({
            id: emp.id,
            name: emp.fullName || emp.name || null,
            email: emp.email,
            phone: emp.phone,
            photoUrl: emp.photoUrl})),
        
        // Relacionamentos Futuros
        idFinancialRecord: null,

        // Auditoria
        createdAt: data.id ? data.createdAt : Timestamp.now(),
        updatedAt: Timestamp.now(),
        createdBy: data.id ? data.createdBy : { uid: authUser?.uid, name: authUser?.displayName || authUser?.email || "Sistema" },
        updatedBy: { uid: authUser?.uid, name: authUser?.displayName || authUser?.email || "Sistema" }
    };
};
